import { gen } from '../../views/utils'

export default {
  auto: '*',
  store: {
    getters: {
      genExpense: gen(() => ({
        groupId: null,
        authorId: null,

        total: null,
        subtotal: null,

        dateAt: new Date(),

        currency: null,
        name: null,
      })),

      _importExpenses: () => ({ dateAt, ...expense }) => ({
        ...expense,
        dateAt,
        // dateAt: VueDate(dateAt),
      }),

      _exportExpenses: () => ({ dateAt, ...expense }) => {
        return {
          ...expense,
          dateAt: new Date(dateAt.obj || dateAt),
          // dateAt: toDateString(dateAt),
        }
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/expenses.js